import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=4a1ee36e&scoped=true"
import script from "./GoodsCard.vue?vue&type=script&lang=ts"
export * from "./GoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=4a1ee36e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ee36e",
  null
  
)

export default component.exports